import {Deserializable} from '../deserializable';
import {ChucVu} from '../danhmuc/chucvu';


export  class StaffChucVu implements Deserializable
{
  public  staffID: number;
  public  chucVuID: number;
  public  chucVuItem: ChucVu;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.chucVuItem= input.chucVuItem!= null?  new ChucVu().deserialize(input.chucVuItem): null;
    return this;
  }
}
